import React, { useEffect, useState } from 'react';

import { fetchProductById } from '../../services/product.service';
import AppModal from '../appModal.component';
import MessageContainer from '../message.component';
import WithLogin from '../withLogin.component';


const ViewProduct = props => {
    const [message, setMessage] = useState({});
    const [product, setProduct] = useState({});
    const [show, setModalShow] = useState(props.open);

    const getProduct = async () => {
        try {
            const resp = await fetchProductById(props.selectedRow.id);
            setProduct(resp);
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
    };

    useEffect(() => {
        setModalShow(props.open);
        getProduct();
        setMessage({});
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleModalClose = () => {
        setModalShow(false);
        props.setEditForm(false);
        if (Object.keys(message).length !== 0) {
            props.reloadDataTable();
        }
    };

    return (
        <AppModal
            size="lg"
            show={show}
            onHide={handleModalClose}
            backdrop="static"
            modalTitle="Product Detail">
            {message && <MessageContainer message={message} />}
            <div className="mt-2">
                <div className="col-md-12">
                    <span className="txt-label">Name</span>
                    <span className="txt-label-value">
                        {product.name}
                    </span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label">Sku</span>
                    <span className="txt-label-value">{product.sku}</span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label">Unit Price</span>
                    <span className="txt-label-value">{product.unit_price}$</span>
                </div>
                <div className="col-md-12">
                    <span className="txt-label">Product Type</span>
                    <span className="txt-label-value">
                        {product.product_type}
                    </span>
                </div>
            </div>
        </AppModal>
    );
};

export default WithLogin(ViewProduct);